var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"7","height":"9","viewBox":"0 0 7 9","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 4.5L0 9V0z","fill":"#231F20","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }